/**
 * `@` mention detection inside the question text.
 *
 * A mention token starts with `@` at the start of the text or after
 * whitespace and runs to the caret without whitespace. The query is the text
 * after the `@`.
 */

export interface MentionRange {
  /** Index of the `@`. */
  readonly start: number;
  /** Caret position; exclusive end of the token. */
  readonly end: number;
  readonly query: string;
}

export function findMentionAtCaret(text: string, caret: number): MentionRange | null {
  const before = text.slice(0, caret);
  const at = before.lastIndexOf("@");
  if (at < 0) return null;
  if (at > 0 && !/\s/.test(before.charAt(at - 1))) return null;
  const query = before.slice(at + 1);
  if (/\s/.test(query)) return null;
  return { start: at, end: caret, query };
}

/** Remove the token and return the new text and caret. */
export function removeMention(
  text: string,
  range: MentionRange,
): { readonly text: string; readonly caret: number } {
  return { text: text.slice(0, range.start) + text.slice(range.end), caret: range.start };
}
